import React, { useState } from 'react';
import { Calendar, RefreshCw } from 'lucide-react';
import DoctorAppointmentCard from './DoctorAppointmentCard';
import PatientFamilyDrawer from './PatientFamilyDrawer';
import VitalsHistoryDrawer from './VitalsHistoryDrawer';

/** Filtered appointment grid for the doctor home using PatientCard design. */
export default function DoctorAppointmentsGrid({ appointments, loading, onOpen }) {
  const [familyPatient, setFamilyPatient] = useState(null);
  const [vitalsPatient, setVitalsPatient] = useState(null);

  if (loading) {
    return (
      <div className="text-center py-16 text-gray-400">
        <RefreshCw className="h-8 w-8 mx-auto mb-3 animate-spin" />
        <p className="text-base">Loading appointments...</p>
      </div>
    );
  }

  if (!appointments?.length) {
    return (
      <div className="text-center py-16 text-gray-400">
        <Calendar className="h-10 w-10 mx-auto mb-3 opacity-40" />
        <p className="text-lg font-medium">No appointments found</p>
        <p className="text-sm mt-1">Try changing the filters or date range</p>
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-3">
        {appointments.map((appt, i) => (
          <DoctorAppointmentCard
            key={appt.appointment_id || appt.queue_entry_id || i}
            appt={appt}
            index={i}
            onOpen={onOpen}
            onFamily={(a) => setFamilyPatient({
              id: a.patient_id, name: a.patient_name, phone: a.phone,
            })}
            onVitals={(a) => setVitalsPatient({
              id: a.patient_id, name: a.patient_name, age: a.age,
            })}
          />
        ))}
      </div>
      <PatientFamilyDrawer
        open={Boolean(familyPatient)}
        patient={familyPatient}
        onClose={() => setFamilyPatient(null)}
        onPick={(p) => onOpen?.({
          patient_id: p.id,
          patient_name: p.name,
          age: p.age,
          gender: p.gender,
          phone: p.phone,
        })}
      />
      <VitalsHistoryDrawer
        open={Boolean(vitalsPatient)}
        patient={vitalsPatient}
        onClose={() => setVitalsPatient(null)}
      />
    </>
  );
}
